import { removeIcon } from '../style'
import { COLORS } from 'helpers/globals'

export default {
  subContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '.5rem',
    '&:not(:last-of-type)': {
      paddingBottom: '.5rem'
    }
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '.5rem',
    '&:not(:first-of-type)': {
      marginLeft: '2.2rem'
    },
    '& span': { width: '7rem' },
    '& input': {
      background: 'white !important',
      borderRadius: '.5rem !important'
    }
  },
  removeIcon: {
    ...removeIcon,
    margin: 0,
    width: '2.2rem',
    fontSize: '1.8rem',
    flexShrink: 0
  },
  viewChoice: {
    fontSize: '1.2rem',
    whiteSpace: 'nowrap',
    padding: '0.25rem 0.6rem',
    borderTop: '1px solid #2972B1',
    borderBottom: '1px solid #2972B1',
    cursor: 'pointer',
    '&:first-of-type': {
      borderRadius: '.75rem 0 0 .75rem',
      borderLeft: '1px solid #2972B1'
    },
    '&:last-of-type': {
      borderRadius: '0 .75rem .75rem 0',
      borderRight: '1px solid #2972B1'
    },
    '&:not(:last-of-type)': { borderRight: `2px solid ${COLORS.secondary}` },
    color: COLORS.primary,
    background: 'white',
    '&:hover:not(.selected)': {
      color: 'white',
      background: COLORS.primary
    },
    '&.selected': {
      color: 'white',
      background: COLORS.primary,
      '&:hover': { cursor: 'not-allowed' }
    }
  },
  toggle: {
    margin: '0 1rem 0 7rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/DoorControllerDesigner/DoorConfiguration/PeripheralDevice/style.js